import { defineComponent as _defineComponent } from 'vue'
import { inject, Ref, ref } from 'vue';

import {
  HeadingDisplay,
  ContentDisplay,
  Heading,
  BaseText,
  ListDisplay,
  ButtonContainer,
  ButtonPrimary
} from '@warrenbrasil/nebraska-web';
import { ExpectedDateModal } from './components/ExpectedDateModal';

import { IPortfolioSheetData } from '@/modules/catalog/services/variable-income';


export default /*#__PURE__*/_defineComponent({
  __name: 'Preview',
  setup(__props) {

const fetchCreatePortfolio = inject('fetchCreatePortfolio', () => ({}));

const portfolioSheetData = inject(
  'portfolioSheetData'
) as Ref<IPortfolioSheetData>;
const isCreatingPortfolio = inject('isCreatingPortfolio') as Ref<boolean>;
const amountFormatted = inject('amountFormatted') as Ref<string>;
const isExpectedDateModalOpen = ref(false);

function onClick() {
  fetchCreatePortfolio();
}

function handleExpectedDateModal() {
  isExpectedDateModalOpen.value = !isExpectedDateModalOpen.value;
}

return { __sfc: true,fetchCreatePortfolio, portfolioSheetData, isCreatingPortfolio, amountFormatted, isExpectedDateModalOpen, onClick, handleExpectedDateModal, HeadingDisplay, ContentDisplay, Heading, BaseText, ListDisplay, ButtonContainer, ButtonPrimary, ExpectedDateModal }
}

})